import PageLoader from '@/components/ui/PageLoader/PageLoader';
import FileSelect from '@/components/FileSelect/FileSelect.vue';
import TutorialModal from '@/components/ui/modals/TutorialModal/TutorialModal.vue';
import { mapState } from 'vuex';
import store from '@/store/store';
import { extend } from 'vee-validate';
import { mimes, size, max } from 'vee-validate/dist/rules';
import ToggleButtons from '@/components/ToggleButtons/ToggleButtons.vue';

// Validation rules
extend('max', {
  ...max,
  message: 'Текст не должен быть больше 80 символов'
});

extend('mimes', {
  ...mimes,
  message: 'Недопустимый формат'
});

extend('size', {
  ...size,
  message: 'Файл не должен превышать 100 Кб'
});

export default {
  data() {
    return {
      options: [
        {
          label: 'Да',
          value: true
        },
        {
          label: 'Нет',
          value: false
        }
      ],
      activeImg: null,
      logo: this.$store.state.branding.logoUrl,
      logoFile: null,
      logoFileUploaded: false,
      background: this.$store.state.branding.backgroundUrl,
      backgroundFile: null,
      backgroundFileUploaded: false,
      tagline: this.$store.state.branding.tagline,
      userInstruction: this.$store.state.branding.userInstruction,
      videoUrl: this.$store.state.branding.videoUrl,
      showCalculation: this.$store.state.branding.showCalculation
    };
  },

  computed: {
    ...mapState({
      firmId: state => state.user.profile.id
    }),

    branding() {
      return this.$store.getters.branding;
    },

    payload() {
      const firmId = store.state.user.profile.id;
      const constructorId = this.$route.params.constructorId;

      return () => {
        return Promise.all([
          this.$store.dispatch('loadBranding', { firmId, constructorId })
        ]);
      };
    }
  },

  methods: {
    pickShowCalculation(value) {
      this.showCalculation = value;
    },
    openImagePopup(image) {
      this.activeImg = image;
      this.$refs.imagePopup.open();
    },

    validateLogo(e) {
      this.logoFile = e;
      this.$refs.logoprovider.syncValue(e);
    },

    validateBackground(e) {
      this.backgroundFile = e;
      this.$refs.backgroundprovider.syncValue(e);
    },

    saveBranding() {
      const { constructorId } = this.$route.params;
      const { firmId, tagline, userInstruction, videoUrl } = this;
      const savePromise = this.$store.dispatch('updateBranding', {
        firmId,
        constructorId,
        data: {
          tagline,
          userInstruction,
          videoUrl,
          showCalculation: this.showCalculation,
          logoImage: this.logoFile != null ? this.logo : null,
          backgroundImage: this.backgroundFile != null ? this.background : null
        }
      });
      savePromise
        .then(() => {
          this.flashSuccess('Данные обновлены');
        })
        .catch(() => {
          this.flashError('Ошибка при сохранении');
        });
      return savePromise;
    }
  },

  watch: {
    logoFile(newFile) {
      const reader = new FileReader();
      reader.onload = () => {
        this.logo = reader.result;
      };
      reader.readAsDataURL(newFile);
    },
    backgroundFile(newFile) {
      const reader = new FileReader();
      reader.onload = () => {
        this.background = reader.result;
      };
      reader.readAsDataURL(newFile);
    },
    branding() {
      const { branding } = this.$store.state;
      this.logo = branding.logoUrl;
      this.background = branding.backgroundUrl;
      this.tagline = branding.tagline;
      this.userInstruction = branding.userInstruction;
      this.videoUrl = branding.videoUrl;
      this.showCalculation = branding.showCalculation;
    }
  },

  components: {
    FileSelect,
    PageLoader,
    TutorialModal,
    ToggleButtons
  }
};
